import { ModalContainer } from '../../../../components/ui/ModalContainer';
import { ErrorMessage } from '../../../../components/errors/ErrorMessage';
import { useState } from 'react';
import { useDeleteVendedorFromVisitaMutation } from '../../../../api/visitasApi';
import { getErrorMessage } from '../../../../utils/errorHelpers';
import { ActionButtons } from 'src/components/ui/ActionButtons';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

interface VendedorItemProps {
    id: number;
    nombre: string;
    visitaId: number;
}

export function VendedorAddedItem({ id, nombre, visitaId }: VendedorItemProps) {
    const [openModal, setOpenModal] = useState(false);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    const [deleteVendedor, { isLoading, isError }] = useDeleteVendedorFromVisitaMutation();

    const onDeleteVendedor = async () => {
        try {
            await deleteVendedor({ visitaId, vendedorId: id }).unwrap();
            setOpenModal(false);
        } catch (error) {
            setErrorMessage(getErrorMessage(error));
        }
    }

    return (
        <>
        <div 
            className="flex gap-x-2 justify-between hover:bg-slate-50 p-2 rounded-md group">
            <div className="flex gap-x-1">
                <div className="w-[20px] h-[20px] bg-gray-500 rounded-full"></div>
                <p className="text-sm font-semibold">{nombre}</p>
            </div>
            <div 
                className="items-center h-[20px] cursor-pointer hover:bg-red-200 rounded-md hidden group-hover:flex" 
                onClick={() => setOpenModal(true)}>
                <CloseRoundedIcon sx={{ height: 20, width: 20 }}/>
            </div>
        </div>

        {openModal && (
            <ModalContainer>
                <div className={`bg-white rounded overflow-auto`}>
                    <div className="flex justify-end bg-gray-100 rounded">
                        <button onClick={() => setOpenModal(false)}>
                            <CloseRoundedIcon  />
                        </button>
                    </div>

                    <div className="w-[500px] p-3">
                        <p className="font-semibold text-center mb-2">¿Esta seguro que quiere eliminar al vendedor {nombre} de esta visita?</p>

                        {isError && (
                            <ErrorMessage customMessage >
                                {errorMessage}
                            </ErrorMessage>
                        )}

                        <ActionButtons
                            isLoading={isLoading}
                            saveButtonText="Eliminar vendedor"
                            saveButtonType="button"
                            onSave={onDeleteVendedor}
                            onCancel={() => setOpenModal(false)}/>
                    </div>

                </div>
            </ModalContainer>
        )}
        </>
    );
}
